import { render } from "./DatasourceView.vue?vue&type=template&id=6f4bff2e"
import script from "./DatasourceView.vue?vue&type=script&lang=js"
export * from "./DatasourceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/DatasourceView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f4bff2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f4bff2e', __exports__)) {
    api.reload('6f4bff2e', __exports__)
  }
  
  module.hot.accept("./DatasourceView.vue?vue&type=template&id=6f4bff2e", () => {
    api.rerender('6f4bff2e', render)
  })

}


export default __exports__